export default __webpack_public_path__ + "9e9e9243a6a673dfcdc49b649c69d1b2.svg";